import { render, staticRenderFns } from "./TableEditorItem.vue?vue&type=template&id=854f14a4&scoped=true"
import script from "./TableEditorItem.vue?vue&type=script&lang=js"
export * from "./TableEditorItem.vue?vue&type=script&lang=js"
import style0 from "./TableEditorItem.vue?vue&type=style&index=0&id=854f14a4&scoped=true&lang=css"
import style1 from "./TableEditorItem.vue?vue&type=style&index=1&id=854f14a4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f14a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854f14a4')) {
      api.createRecord('854f14a4', component.options)
    } else {
      api.reload('854f14a4', component.options)
    }
    module.hot.accept("./TableEditorItem.vue?vue&type=template&id=854f14a4&scoped=true", function () {
      api.rerender('854f14a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableEditorItem.vue"
export default component.exports